import { Injectable } from '@angular/core';

@Injectable()
export class DataService {
    constructor() { }

    //service request listing
    filterHistory = {
        requestStatus: [],
        orderBy: ""
    };

    filter = {
        requestStatus: [],
        orderBy: ""
    };


    //rental contract listing
    rcFilter = {
        contractStatus: [],
        startDate: "",
        endDate: ""
    };

    rcFilterHistory = {
        contractStatus: [],
        startDate: "",
        endDate: ""
    };


}
